export default [
  {
    resource: "administration",
    header: "Usuaris",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "LifeBuoyIcon",
    title: "Proveïdors",
    route: "foravila-providers-list",
  },
  {
    action: "manage",
    resource: "administration",
    title: "Clients",
    route: "foravila-clients-list",
    icon: "BriefcaseIcon",
  },
];
